module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component component-backoffice-client client card"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "inner-content"
  }, [_c('cardN', {
    attrs: {
      "columns": 7,
      "showBullets": true,
      "showAction": true
    }
  }, [_c('div', {
    staticClass: "field-client-dropdown-buttons",
    attrs: {
      "slot": "actionBullets"
    },
    slot: "actionBullets"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('client-action-buttons', {
    attrs: {
      "client": _vm.item
    }
  })], 1)], 1), _c('div', {
    staticClass: "field field-client-status",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('status', {
    staticClass: "float-left",
    attrs: {
      "status": _vm.item.status
    }
  }), _vm._v(_vm._s(_vm.item.id)), (_vm.item.federation !== null) ? _c('div', {
    staticClass: "field-value"
  }, [_vm._v("Federation: " + _vm._s(_vm.item.federation.name))]) : _vm._e()], 1), _c('div', {
    staticClass: "field field-name-surname",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_c('div', {
    staticClass: "name-surname"
  }, [_vm._v(_vm._s(_vm.item.name) + " " + _vm._s(_vm.item.surname))]), _c('div', {
    staticClass: "organization-name"
  }, [_vm._v(_vm._s(_vm.item.organization_name))])]), _c('div', {
    staticClass: "field field-billing-address",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.billing_address.city))])]), _c('div', {
    staticClass: "field field-phone",
    attrs: {
      "slot": "n4"
    },
    slot: "n4"
  }, [(_vm.item.main_driver) ? _c('div', {
    staticClass: "field-value"
  }, [_c('div', {
    staticClass: "phone"
  }, [_vm._v(_vm._s(_vm.item.main_driver.phone))]), _c('div', {
    staticClass: "mobile"
  }, [_vm._v(_vm._s(_vm.item.main_driver.mobile))])]) : _vm._e()]), _c('div', {
    staticClass: "field field-total-drivers",
    attrs: {
      "slot": "n5",
      "shrink": "shrink"
    },
    slot: "n5"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.drivers.length))])]), _c('div', {
    staticClass: "field field-wallet-balance",
    attrs: {
      "slot": "n6"
    },
    slot: "n6"
  }, [_c('div', [_vm._v("Unpaid: " + _vm._s(_vm.$priceWithcurrency(_vm.item.unpaid_balance)))]), _c('div', [_vm._v("Not invoiced: " + _vm._s(_vm.$priceWithcurrency(_vm.item.wallet.balance)))])]), _c('div', {
    staticClass: "field field-active-since",
    attrs: {
      "slot": "n7"
    },
    slot: "n7"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))]), _c('div', {
    staticClass: "field field-url-detail",
    attrs: {
      "slot": "actionPage"
    },
    slot: "actionPage"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'client',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)])], 1) : _vm._e(), (_vm.$is('client-card')) ? _c('div', {
    staticClass: "client-card card"
  }, [_c('div', {
    staticClass: "row inner-content"
  }, [_c('div', {
    staticClass: "columns shrink"
  }, [_vm._v(_vm._s(_vm.item.picture))]), _c('div', {
    staticClass: "columns"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'client',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.item.name) + " " + _vm._s(_vm.item.surname) + " (CL" + _vm._s(_vm.item.id) + ")")])]), _vm._v(_vm._s(_vm.item.client_organization_name))], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns text-right"
  }, [(_vm.item.main_driver.mobile) ? _c('a', {
    staticClass: "fa fa-phone fa-lg",
    attrs: {
      "href": 'tel:' + _vm.item.main_driver.mobile
    }
  }) : _vm._e(), (_vm.item.email) ? _c('a', {
    staticClass: "fa fa-envelope fa-lg",
    attrs: {
      "href": 'mailto:' + _vm.item.email
    }
  }) : _vm._e()])])]) : _vm._e(), (_vm.$is('client-approval-card')) ? _c('div', {
    staticClass: "client-approval-card"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "row inner-content align-middle"
  }, [_c('div', {
    staticClass: "columns shrink"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'left'
    }
  }, [_c('client-action-buttons', {
    attrs: {
      "client": _vm.item
    }
  })], 1)], 1), _c('div', {
    staticClass: "columns small-3 large-1"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'driver',
        params: {
          id: _vm.item.main_driver.id
        }
      }
    }
  }, [_c('thumbnail', {
    attrs: {
      "image": _vm.item.main_driver.profile_picture
    }
  })], 1)], 1), _c('div', {
    staticClass: "columns small-3 large-2"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.item.name) + " " + _vm._s(_vm.item.surname))]), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.item.id))]), (_vm.item.federation !== null) ? _c('p', [_vm._v("Federation: " + _vm._s(_vm.item.federation.name))]) : _vm._e()]), _c('div', {
    staticClass: "columns text-center align-middle"
  }, [_c('AccountStatus', {
    attrs: {
      "accountStatus": _vm.accountStatus
    }
  })], 1), _c('div', {
    staticClass: "columns shrink text-center align-middle"
  }, [_c('i', {
    staticClass: "fa fa-clock-o fa-2x",
    class: {
      activeIcon: true
    }
  }), _c('p', {
    staticClass: "no-wrap"
  }, [_vm._v(_vm._s(_vm.daysWaiting(_vm.item.updated)))])]), _c('div', {
    staticClass: "columns shrink text-right align-middle"
  }, [_c('h5', {
    staticClass: "mb-0 no-wrap"
  }, [_vm._v("created: " + _vm._s(_vm.formatDate(_vm.item.created)))]), _c('h5', {
    staticClass: "mb-0 no-wrap"
  }, [_vm._v("updated: " + _vm._s(_vm.formatDate(_vm.item.updated)))])]), _c('div', {
    staticClass: "columns shrink"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'client',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)])])]) : _vm._e(), (_vm.$is('personal-data')) ? _c('div', {
    staticClass: "inner-content"
  }, [_c('h3', [_vm._v("Personal Data")]), _c('hr'), _c('cardN', {
    attrs: {
      "columns": 3
    }
  }, [_c('div', {
    staticClass: "field field-first-name",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("First Name")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.name))])]), _c('div', {
    staticClass: "field field-last-name",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Last name")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.surname))])]), _c('div', {
    staticClass: "field field-client-type",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Client Type")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.client_type.type))])])]), _c('cardN', {
    attrs: {
      "columns": 3
    }
  }, [_c('div', {
    staticClass: "field field-member-since",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Member Since")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])])]), (_vm.item.federation !== null) ? _c('cardN', {
    attrs: {
      "columns": 3
    }
  }, [_c('div', {
    staticClass: "field field-federation",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Federation")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.federation.name))])])]) : _vm._e()], 1) : _vm._e(), (_vm.$is('contacts')) ? _c('div', {
    staticClass: "inner-content"
  }, [_c('h3', [_vm._v("Contacts")]), _c('hr'), _c('simple-columns2', [_c('div', {
    staticClass: "field field-email-address",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Mail Address")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.email))])]), _c('div', {
    staticClass: "field field-address",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Address")]), _c('div', {
    staticClass: "address"
  }, [_vm._v(_vm._s(_vm.item.address.street) + " " + _vm._s(_vm.item.address.city) + " " + _vm._s(_vm.item.address.country))]), _c('div', {
    staticClass: "postal-code"
  }, [_vm._v(_vm._s(_vm.item.address.postal_code))])]), _c('div', {
    staticClass: "field field-phone",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Phone")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.phone))])])])], 1) : _vm._e(), (_vm.$is('billing')) ? _c('div', {
    staticClass: "inner-content"
  }, [_c('h3', [_vm._v("Billing Details")]), _c('hr'), _c('cardN', {
    attrs: {
      "columns": 3
    }
  }, [_c('div', {
    staticClass: "field field-organization-name",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Organization Name")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.organization_name))])]), _c('div', {
    staticClass: "field field-fiscal-code",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Fiscal Code")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.fiscalCode))])])]), _c('cardN', {
    attrs: {
      "columns": 3
    }
  }, [_c('div', {
    staticClass: "field field-vat-number",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Vat number")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.vat_number))])]), _c('div', {
    staticClass: "field field-billing-address",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Billing Address")]), _c('div', {
    staticClass: "address"
  }, [_vm._v(_vm._s(_vm.item.billing_address.street) + " " + _vm._s(_vm.item.billing_address.city) + " " + _vm._s(_vm.item.billing_address.country))]), _c('div', {
    staticClass: "postal-code"
  }, [_vm._v(_vm._s(_vm.item.billing_address.postal_code))])])]), _c('cardN', {
    attrs: {
      "columns": 1
    }
  }, [_c('div', {
    staticClass: "field field-extra",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, _vm._l((_vm.extra), function(value, label) {
    return _c('div', {
      staticClass: "values"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(label))]), _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(value))])])
  }), 0)])], 1) : _vm._e(), (_vm.$is('main-driver')) ? _c('div', {
    staticClass: "inner-content"
  }, [_c('h3', [_vm._v("Main driver")]), _c('driver', {
    attrs: {
      "type": 'driver-card',
      "item": _vm.item.main_driver
    }
  })], 1) : _vm._e(), (_vm.$is('client-status')) ? _c('div', {
    staticClass: "client-status"
  }, [_c('p', [_vm._v("Status"), _c('br'), _vm._v(_vm._s(_vm.item.status))])]) : _vm._e(), (_vm.$is('client-card2')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "driver-card inner-content"
  }, [_c('div', {
    staticClass: "row collapse align-middle"
  }, [_c('div', {
    staticClass: "columns small-offset-1"
  }, [_c('div', {
    staticClass: "client"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'client',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.item.name) + " " + _vm._s(_vm.item.surname) + " (CL" + _vm._s(_vm.item.id) + ")")])])], 1)])]), _c('div', {
    staticClass: "row collapse"
  }, [_c('div', {
    staticClass: "columns text-right"
  }, [(_vm.item.main_driver.mobile) ? _c('a', {
    staticClass: "fa fa-phone fa-lg",
    attrs: {
      "href": 'tel:' + _vm.item.main_driver.mobile
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "columns text-right small-1"
  }, [(_vm.item.email) ? _c('a', {
    staticClass: "fa fa-envelope fa-lg",
    attrs: {
      "href": 'mailto:' + _vm.item.email
    }
  }) : _vm._e()])])])]) : _vm._e(), (_vm.$is('federationList')) ? _c('div', {
    staticClass: "inner-content federation-list"
  }, [_c('cardN', {
    attrs: {
      "columns": 4
    }
  }, [_c('div', {
    staticClass: "field field-first-name",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("First Name")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.name))])]), _c('div', {
    staticClass: "field field-last-name",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Last name")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.surname))])]), _c('div', {
    staticClass: "field field-client-type",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Client Type")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.client_type.type))])]), _c('div', {
    staticClass: "field field-url-detail text-right",
    attrs: {
      "slot": "n4"
    },
    slot: "n4"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'client',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)])], 1) : _vm._e(), ((_vm.item.status === 'SUSPENDED' || _vm.item.status === 'ON HOLD') && _vm.type === 'highlightedNotes') ? _c('div', {
    staticClass: "card"
  }, [_c('DriverNotes', {
    attrs: {
      "driver_id": _vm.item.main_driver.id,
      "type": 'highlightedNotes'
    },
    on: {
      "notes": _vm.retriveLastNotes
    }
  }), _c('div', {
    staticClass: "row column pl-2 pr-2 pt-2 pb-2"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("last two notes")]), _vm._l((_vm.lastNotes), function(lastNote, key) {
    return _c('div', {
      staticClass: "row column small-12"
    }, [_vm._v(_vm._s(lastNote))])
  })], 2)], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2809c802!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Client.vue
// module id = 2295
// module chunks = 1